var _path, _path2, _path3;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Recruitment = function Recruitment(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10ZM9 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M7.879 16.879A3 3 0 0 1 10 16h1a1 1 0 1 0 0-2h-1a5 5 0 0 0-5 5v2a1 1 0 1 0 2 0v-2a3 3 0 0 1 .879-2.121Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 17.5a3.5 3.5 0 1 1 6.58 1.665l2.127 2.128a1 1 0 0 1-1.414 1.414l-2.128-2.128A3.5 3.5 0 0 1 13 17.5Zm3.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Recruitment;